import { Component, OnInit, NgZone, ViewChild, ViewContainerRef, ComponentFactoryResolver, Input, Pipe} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AspRequestDetailsPopUpComponent } from '../../auto-spare-parts/asp-request-details-pop-up/asp-request-details-pop-up.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AspRequestDetailsService } from '../../auto-spare-parts/asp-request-details/asp-request-details.service';
import { AspOrderDetailsComponent } from '../asp-order-details/asp-order-details.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FuseConfigService } from '@fuse/services/config.service';
import { S3ImageUploadService } from 'app/shared/s3-image-upload.service';
import { AspCheckinReportsService} from '../asp-checkin-reports/asp-checkin-reports.service';
import { SideBarJobcardService } from '../side-bar-jobcard/side-bar-jobcard.service'
import { MyJobCardsDetailsService } from '../my-job-cards-details/my-job-cards-details.service';
import { HttpClient } from '@angular/common/http';
import { AspLoadingService } from '../asp-loading/asp-loading.service'; 
import { AspJobcardQuotationComponent } from '../asp-jobcard-quotation/asp-jobcard-quotation.component';
import { GlobalVariable } from 'app/main/globals';
import { AspMyRequestService } from '../asp-my-request/asp-my-request.service';
import { AspInstantRequestComponent } from '../asp-instant-request/asp-instant-request.component';

interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}

interface Filters {
  jobCardStatus: FilterOption[];
}

export type PartOption = 'OES' | 'OEM';

interface Part {
  id: string;
  title: string;
  brand: string;
  partNumber: string;
  qty: number;
  priceOES: number;
  priceOEM: number;
  selected: boolean;
  option: PartOption;
  recommended: PartOption;
  
}
// @Pipe({
// name: 'formatEdt'
// })

@Component({
  selector: 'app-asp-request-details',
  templateUrl: './asp-request-details.component.html',
  styleUrls: ['./asp-request-details.component.scss'],
})

export class AspRequestDetailsComponent implements OnInit {
  spareRequestId!: number;
  activeTab: string = 'requests'; 
  selectAll: boolean = false; 
  sidebarOpen: boolean = false; 
  items: any;
  requestDetails: any; 
  spareRequestItemList: any; 
  quotationreceived: any[] = []; 
  quotationapproved: any[] = []; 
  quoteApproved: boolean = false; 
  id: any;
  itemDetails: any;
  quoteReceivedPrice: number=0;
  quoteApprovedPrice: number=0;
  selectedItemsCount: any;
  totalSelectedPrice: number = 0;
  selectedItemsUnit:number=0;
  bitModule: number;
  bidItems: any;
  quoteReceived: boolean;
  totalMRP: number = 0;
  Quotereceived: any;
  sidebarOpenQuote: boolean = false;
  previewImageUrl: string | null = null;
  imagePreviewOpen = false;
  
  customerQuotation: any[]=[];
  customerQuotationPrice: number=0;
  totalSelectedPriceQuote: number=0;
  selectedItemsCountQuote: number=0;
  selectAllQuote:boolean = false; 
  isPopupOpen = false;
  successIcon: any = '../../../../assets/icons/icons8-ok.gif';
  itemQuote: any;
  isPopupOpenEdit: boolean;
  selectedItems: any[];
  loading: boolean = false;
  orderList: any[] = [];
  filteredOrderList: any[]=[];
  orderDeliveryTimeFormatted: string;
  item: any;
  resData: any;
  quoteShipping: any;
  regno: any;
  @Input() quoteId: string | null = null;  
  @Input() requestId: number | null = null;  
  // @Input() jobCard: number | null = null;  
  @Input() jobCard: number | null = 996;  
  itemDetail: any;
  selectedItemsQuote: any[];
  dataid: any;
  isMobile: boolean;
  orders: any;
  isSidebarOpen = false;
  searchText: string = '';
  searchQuery: string = '';
  filteredItems: any[] = [];
  isAddLabour = false;
  filteredItems1: any[] = [];
  isEditLabourSidebarOpen=false;
  selectedLabour: any = { name: '', price: '' };
  formSubmitted: boolean = false;
  showCancelConfirmation: boolean = false;
  showCancelSuccess: boolean = false;
  labourselectedItems = 0;
  totallabourSelectedPrice :number=0;
  showSkipConfirmation = false;
  laborDetails: FormGroup;
  labourItemsCount: number = 0;
  searchWord: string = '';
  labourListData: any;
  // labourName: any;
  labourAmount: any;
  labourId: any;
  labourName: any;
  totalSelectedPriceQuote1: number=0;
  partNumber: any;
  selectedItemsLabourQuote: any;
  unitPrice: any;
  selectedLabourCount:any;
  sparePartsTotal: any;
  selectedLabours: any;
  
  activeUrl: string;
  isRequestDetails: boolean;
  data: any;
  accessoriesYes: any;
  isDropdownOpen = false;
  serviceList: any;
  accessories: any;
  filteredIssues: any;
  car =  {
    regNumber: '',
    vin: localStorage.getItem('vin') || '',
    engineNumber: '',
    odometerReading: '',
    lastServiceDate: '',
    selectedServices: [] as string[],
  }
  fuelAndAccessories: {
    fuelLevel: number;
    checkedItems: string[];
  } = {
    fuelLevel: 0, // Default fuel level
    checkedItems: [] // Initially no items selected
  }
  isSearchOpen = false;
  issuesData: any;
  selectedIssues: string[] = [];
  images: any;
  request: any;
  formData: { engineNumber: any; odometer: any; lastServiceDate: any; customerName: any; customerMobile: any; customerEmail: any; };
  damageImages: [];
  variantKey: any;
  imagesS3: any;
  QuoteId: any;
  registrationNumber: any;
  
  selectedLaboursCount: any;
  quoteItemStatus: any;
  selectedApprovedItemsCount: number;
  totalApprovedSelectedPrice: any;
  totalSelectedApprovedPrice: any;
  customerquoteid: any;
  selectedLabourslength: any;
  customerQuotationCount: number;
  status: any;
  isOpen: boolean;
  
  @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;  
  @ViewChild('createQuotationContainer', { read: ViewContainerRef }) createQuotationContainer!: ViewContainerRef;  
  jobcardId: any;
  bookingId: any;
  isQuotationPopup: any = false; 
  notes: any;
  carSize: any;
  magicQuote: any;
  totalOEM: number;
  totalOES: number;
  openPopup: boolean;
  parts: any;
  openEditIndex: boolean;
  isInsurance: boolean;
  selectedType: string;
  selectedCompany: string;
  insuranceGarageId: string;
  showError: boolean;
  showError1: boolean;
  insurance: any;
  filteredList: any[];
  showPopupinfo: boolean;
  selectedImages: File[] = [];
  // imagePreviews: string[] = [];
  selectedPreview: 'OEM' | 'OES' = 'OES'; // default (optional)
  approved: boolean;
  approveData: any;
  quoteApprovedSellingPrice: number;
  totalItems: number;
  oesAvailableItems: number;
  oemAvailableItems: number;
  isOESFull: boolean;

  imagePreviews: { id: number; url: string }[] = [];  // ✅ NEW
  imageIds = [];

  constructor(
    private _fuseConfigService: FuseConfigService,
    public dialog: MatDialog,
    private aspRequestDetailsService: AspRequestDetailsService,
    private zone: NgZone,
    private route: ActivatedRoute,
    private resolver: ComponentFactoryResolver,
    private location: Location,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private breakpointObserver: BreakpointObserver,
    private viewContainerRef: ViewContainerRef,
    private router: Router,
    private AspCheckinReportsService:AspCheckinReportsService,
    private sideBarJobcardService:SideBarJobcardService,
    private myJobCardsDetailsService:MyJobCardsDetailsService,
    private s3ImageUploadService: S3ImageUploadService,
    private http: HttpClient,
    private aspLoadingService: AspLoadingService,
    private aspMyRequestService: AspMyRequestService,
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); }


  @ViewChild('intstantorder', { read: ViewContainerRef }) containers!: ViewContainerRef;
  ngOnInit(): void {
    this.activeUrl = this.router.url;
    this.isRequestDetails = this.activeUrl.includes('/request-details');
    if(this.requestId && this.requestId!==null){
      this.id = this.requestId;
    }else{ 
      this.route.queryParams.subscribe(params => {
     
      // this.id = params.get('id');
        this.id = params['id'];        
        // this.regno = params['regNo'];
        // this.status= params['status']    
       
      });
    }
        const currentUrl = this.router.url;
    // console.log('Current URL:', currentUrl);

    if (currentUrl.includes('approve')) {
      this.activeTab = 'quote-approved';
    }
    if (currentUrl.includes('received')) {
      this.activeTab = 'quote-received';
    }
    this.getRequestDetails();
    this.laborDetails = this._formBuilder.group({
      labourName: ['', [Validators.required, Validators.minLength(2)]], 
      labourAmount: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
    this.unitPrice=this._formBuilder.group({
      unitprice:['',[Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
    });
    
    
    if (this.data && this.data.serviceType && this.data.serviceType.length > 0) {
      this.data.serviceType.forEach(service => {
        // Find the checkbox in service list and set it checked
        const checkbox = this.serviceList.find(item => item === service);
        if (checkbox) {
          this.car.selectedServices.push(checkbox);
        }
      });
    }
    if (this.data && this.accessoriesYes && this.accessoriesYes.length > 0) {
      this.accessoriesYes.forEach(accessory => {
        // Find the checkbox in service list and set it checked
        const checkbox = this.accessories.find(item => item === accessory);
        if (checkbox) {
          this.fuelAndAccessories.checkedItems.push(checkbox);
        }
      });
    }
    if (this.data && this.data.issues && this.data.issues.length > 0) {
      this.data.issues.forEach(issue => {
        // Find the checkbox in service list and set it checked
        const checkbox = this.issuesData.find(item => item === issue);
        if (checkbox) {
          this.selectedIssues.push(checkbox);
        }
      });
    }
 
  }

  get up() {
    return this.unitPrice.controls;
  }
    
    get ld() {
      return this.laborDetails.controls;
    }
    

  labourList() {
    const garageKey = localStorage.getItem('garageKey');
    const rateCardApplicable = null;
    const carSize = null;
    if (garageKey) {
      this.aspRequestDetailsService.displayLabourList(garageKey,rateCardApplicable,carSize).subscribe(
        (result) => {
          const res = JSON.parse(JSON.stringify(result));
          if (res.code === 200) {
            if (!this.selectedItemsLabourQuote) {
              this.selectedItemsLabourQuote = [];
            }

            // Clear existing data to avoid duplicates
            this.labourListData = [];

            // Map the fetched data and cross-validate with selected items
            this.labourListData = res.data.map((labour: any) => {
              const isSelected = this.selectedItemsLabourQuote.some(
                (selectedItem: any) => selectedItem.id === labour.id
                
              );
              return {
                ...labour,
                selected: isSelected, // Set selected based on previous selection
              };
            });
            this.updateSelectedLabourItems();
            this.updateSelectedItemsQuote();
            // Update the filtered items
            this.filteredItems1 = [...this.labourListData];
          }
        },
        (error) => {
          console.error('Error fetching labour list:', error);
        }
      );
    } else {
      console.warn('Garage key not found in localStorage.');
    }
  }


  addLabour()
    {
      // console.log(this.ld.labourAmount.value)
      const updatedLabourName = this.ld.labourName.value;
      const updatedLabourAmount = this.ld.labourAmount.value;
      const garageKey = localStorage.getItem('garageKey');
      const rateCardType = this.rateCardType ? this.rateCardType : 'Default';
      const carSize = this.carSize ?? null;
      // console.log("============== rateCardType:", rateCardType);
      // console.log("============== carSize:", carSize);
      this.aspRequestDetailsService.addLabourList(garageKey,updatedLabourName,updatedLabourAmount,rateCardType,carSize).subscribe(
        (result) => {
          const res = JSON.parse(JSON.stringify(result));
          if (res.code === 200) {
            // this.toastr.success("Labour Added Successfully")
            // console.log("addLabour--",res);
            // console.log("==============ratecardtype",this.rateCardType);
    // console.log("===========carSize",this.carSize);
            this.updateSelectedItemsQuote();
            this.labourList();
            this.toastr.success("Labour Added Successfully");

          }

          this.closeLabourEditSidebar();
          this.ngOnInit();
    });
  }
  rateCardType(arg0: string, rateCardType: any) {
    throw new Error('Method not implemented.');
  }

  onCheckboxChange(labour: any, event: Event): void {
    if (!labour) {
      console.error('Labour object is undefined');
      return;
    }
    labour.selected = (event.target as HTMLInputElement).checked;
    this.updateSelectedLabourItems();
    this.updateSelectedItemsQuote(); // Sync after updating labour
  }
  onLabourSelectionChange(labour: any): void {
    if (!labour) {
      console.error('Labour object is undefined');
      return;
    }

    // Update the selected property
    labour.selected = labour.selected || false;

    // Sync the selected items list
    this.selectedItemsLabourQuote = this.labourListData.filter(l => l.selected);
    this.selectedLabourCount = this.selectedItemsLabourQuote.every(labour => labour.selected).length;
    // Update counts and prices
    this.updateSelectedLabourItems();
    this.updateSelectedItemsQuote();
  }





  openSkipConfirmation(){
    this.showSkipConfirmation = true;
  }
  closeSkipConfirmation(): void {
    this.showSkipConfirmation = false;
  }
  confirmSkip(): void {
    this.showSkipConfirmation = false;
    this.isAddLabour = false;
    // console.log('Skip confirmed!');
  }

  AddItems()
  {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.searchText = '';
    this.filteredItems = [];
  }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  onLabourSearch(): void {
    // console.log('Search Triggered:', this.searchText);
    const query = this.searchText?.toLowerCase();
    if (query) {
      this.labourListData = this.labourListData.filter(item =>
        item.labourName?.toLowerCase().includes(query)
      );
    // if(this.searchText=''){
    //   this.labourList();
    // }
    } else {
      // console.log('Resetting filteredItems1 to full list.');
      this.filteredItems1 = [...this.labourListData]; // Reset to full list
    }
    // console.log('Filtered Items:', this.filteredItems1);
  }

  clearLabourSearch(){
    this.searchText='';
    this.labourList();
  }

  clearSearch() {
    this.searchWord = '';

    this.filteredItems = [];
  }
  addLabourSidebar(){
    this.isAddLabour = !this.isAddLabour; 
    this.labourList();
    
  }
  labourRedirectSidebar()
  {
    this.isAddLabour=false;
    this.selectedLabourCount=0;
    }
  toggleSelect() {
    this.selectAll = !this.selectAll;
  }

  openLabourEditSidebar(item: any = null) {
    this.isEditLabourSidebarOpen = true;
    // this.isAddLabour = item ? false : true;
    this.isSidebarOpen = false;
  // console.log("sdjfjsdfjisdf")
    if (item) {
      this.selectedLabour = { ...item };
      this.labourName = this.selectedLabour.labourName;
      this.labourAmount = this.selectedLabour.labourAmount;
      this.labourId = this.selectedLabour.labourId;
      this.id = this.selectedLabour.id;
      // console.log("Editing Labour:", this.selectedLabour);
    } else {
      this.selectedLabour = { name: '', price: null };
      // console.log("Adding New Labour:", this.selectedLabour);
    }
  }


  closeLabourEditSidebar() {
    this.isEditLabourSidebarOpen = false;
      this.selectedLabour = { labourName: '', labourAmount: null };
    this.isAddLabour=false;
    

  }
  saveLabour(): void {
    // console.log("Labour Name:", this.ld.labourName.value);
    // console.log("Labour Amount:", this.ld.labourAmount.value);

    const updatedLabourName = this.ld.labourName.value;
    const updatedLabourAmount = this.ld.labourAmount.value;
    const garageKey = localStorage.getItem('garageKey');
    const rateCardType = this.rateCardType ? this.rateCardType : 'Default';
  const carSize = this.carSize ?? null;
  const status = this.status ?? 1;

  // console.log("============== rateCardType:", rateCardType);
  // console.log("============== carSize:", carSize);
    this.aspRequestDetailsService
      .editLabour(this.id, this.labourId, garageKey, updatedLabourName, updatedLabourAmount,rateCardType,carSize,status)
      .subscribe(
        (result) => {
          // console.log('API Response:', result); // Log API response
          const res = JSON.parse(JSON.stringify(result));
          if (res.code === 200) {
            // console.log('Labour edited successfully:', res);
            this.toastr.success("Labour saved Successfully");
            // this.updateSelect
            // LabourItems();
            // this.updateSelectedItemsQuote();
            this.labourList(); 
          } else {
            console.warn('Unexpected response code:', res.code);
          }
        },
        (error) => {
          console.error('Error editing labour:', error);
        }
      );

    this.closeLabourEditSidebar();
  }


  // openPopUp(){
  //   this.showCancelConfirmation = true;
  //   this.isAddLabour = false;
  // }
  closeCancelPopup(): void {
    this.showCancelConfirmation = false;
  }
  toggleSelectItem(): void {

    this.selectedItemsLabourQuote = this.labourListData.filter(item => item.selected);
    this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
      (sum, item) => sum + (item.labourAmount || 0),0);
    // console.log('Selected Items:', this.selectedItemsQuote);
    // console.log('Total Selected Price:', this.totalSelectedPriceQuote1);
    this.isAddLabour = false;
  }
  closeAll(): void{
    this.isAddLabour = false;
    this.isEditLabourSidebarOpen = false;
    this.sidebarOpenQuote = false; 
  }


  loadorderdetails(orderKey) {
  const factory = this.resolver.resolveComponentFactory(AspOrderDetailsComponent);
  const componentRef = this.container.createComponent(factory);
  const componentBInstance = componentRef.instance as AspOrderDetailsComponent;
  componentBInstance.closeSidebar(true);
  componentBInstance.getOrderDetails(orderKey);
  }
  // openPopup(): void {
  //   this.isPopupOpen = true;
  //   this.showSkipConfirmation = false;
  //   this.isAddLabour = false;
  //   this.CloseSidebarQuote();
  //   this.submitData(); 
  // }


  // closePopup(): void {
  //   this.isPopupOpen = false;
  // }
  getMakeImageUrl(make: string):string{
    if(make){
      const makeWithoutSpaces = make.toLowerCase().replace(/\s+/g, '');
      return `https://cube.getpitstop.com/assets/img/${makeWithoutSpaces}.png`;
    }else {
      return
    }
  }
  onSearch(item: any) {
    if (!this.searchWord.trim()) {
      return;
    }
    const garageKey=localStorage.getItem('garageKey');
    if( this.isRequestDetails){
     this.variantKey=localStorage.getItem('variantKey');
    //  console.log("this.isRequestDetails",this.variantKey)
    }
   
    this.aspRequestDetailsService
      .searchItems(garageKey, this.searchWord, this.variantKey)
      .subscribe(
        (result) => {
          const res = JSON.parse(JSON.stringify(result));
          
          if (res.code === 200) {
            // console.log('Search results:', res.data);
            this.filteredItems = res.data;
            this.partNumber= res.data.map((item: any) => item.partNumber);
          } else {
            console.error('Search failed with code:', res.code);
          }
        },
        (error) => {
          console.error('Error during search:', error);
        }
      );
  }
  
  addItemToQuotation(item: any) {
    // console.log('Attempting to add item:', item);
    // console.log('Current customerQuotation list:', this.customerQuotation);
    this.customerQuotationCount=this.customerQuotation.length;
    // console.log("customerquotecount-------------",this.customerQuotationCount);
  
    // Find an existing item with the same partNumber
    const existingItem = this.customerQuotation.find(quote => quote.partNumber === item.partNumber);
  
    if (existingItem) {
      // If found, increase the quantity
      existingItem.itemQuantity += 1;
      // console.log('Item already exists, increased quantity:', existingItem);
    } else {
      // Otherwise, add the new item to the list
      const newItem = {
        itemId: item.itemId,
        itemName: item.name,
        brand: item.brand,
        partNumber: item.partNumber,
        mrp: item.mrp,
        itemQuantity: 1,
        selected: true,
        edt: new Date(),
      };
      this.customerQuotation.push(newItem);
      // console.log('Item added successfully:', newItem);
      this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);

      
    }
    this.isSidebarOpen = false;
    this.clearSearch();
    this.updateSelectedItemsQuote();

  }
  
  getRequestDetails() {
    this.quotationapproved=[]
    this.quotationreceived=[]
    this.requestDetails =[]
    this.quoteApprovedPrice=0;
    this.quoteApprovedSellingPrice=0;
    this.aspLoadingService.show();
    const garageKey = localStorage.getItem('garageKey');
    const requestId = this.id;
    const userKey = localStorage.getItem('spareUserKey');

    this.aspRequestDetailsService.requestDetails(garageKey, requestId, userKey).subscribe(result=>{
      this.aspLoadingService.hide();
      const res = JSON.parse(JSON.stringify(result));
      if (res.code === 200) {
        // console.log("this.requestDetails",this.requestDetails);
        this.requestDetails = res.data;
        // console.log("this.requestDetails",this.requestDetails);
        this.spareRequestId = this.requestDetails?.spareRequest?.id;
        // console.log("Loaded Request ID:", this.spareRequestId);
        this.magicQuote=this.requestDetails?.spareRequest?.magicQuote;
        this.jobcardId = this.requestDetails?.spareRequest?.jobcardId ? this.requestDetails.spareRequest.jobcardId : '';
        this.quoteId = this.requestDetails?.spareRequest?.quoteId ? this.requestDetails.spareRequest.quoteId : 0;
        this.bookingId = this.requestDetails?.spareRequest?.bookingId ? this.requestDetails.spareRequest.bookingId : 0;
        this.notes = this.requestDetails?.spareRequest?.notes ? this.requestDetails.spareRequest.notes.split(',') : '';
        this.registrationNumber = this.requestDetails?.spareRequest?.registrationNumber ? this.requestDetails?.spareRequest?.registrationNumber : 0;
        this.imagePreviews = [];
        const imagesFromApi = this.requestDetails.requestImageList || [];
                imagesFromApi.forEach(img => {
           this.imagePreviews.push({
              id: img.entityId,   // ✅ FIXED — use entityId
              url: img.url
            });
        });
        // console.log("Images loaded from API:", this.imagePreviews);
        // console.log('Request Details:', this.requestDetails);
        this.requestDetails.orders.forEach(order => {
          order.titleName = this.formatOrderDeliveryTime(order.orderConfirmTime, order.orderDeliveryTime);
          this.filteredOrderList.push(order);
          // console.log("getAll----",this.filteredOrderList);
        });
             this.requestDetails.orders.forEach(order => {
  // Add formatted delivery time
  // order.titleName = this.formatOrderDeliveryTime(order.orderConfirmTime, order.orderDeliveryTime);

  // Get all order items
  const orderItems = order.orderItems;


  // Flatten ALL packed items from all packageDetails
  const packedItems = order.packageDetails.flatMap(pkg => pkg.items);

  // Find which orderItems are NOT packed (compare by partName)
  order.notPackedItems = orderItems.filter(orderItem =>
    !packedItems.some(packedItem => packedItem.partNumber === orderItem.partNumber)
  );

  // console.log("order.notPackedItems", order.notPackedItems);

  // Format delivery time for each package
  order.packageDetails.forEach(pkg => {
    pkg.time = this.formatOrderDeliveryTime(order.orderConfirmTime, pkg.deliveryTime);
  });

  // ✅ If there are any notPackedItems, add them as a new package block
 
});
        this.requestDetails.spareRequestItemList.forEach(item => {
          this.requestDetails.bidDetails.forEach(bid => {
            if(bid.estimateItem[item.itemName]){            
              let bidItem=bid.estimateItem?.[item.itemName]?.at(-1);
                bidItem.itemName = item.itemName;
                bidItem.itemQuantity = item.itemQuantity;                                
                bidItem.itemStatus = item.status; 
                bidItem.itemId = item.id;
                bidItem.lineitemId = item.lineitemId;
                bidItem.spareQuotationId = item.spareQuotationId;
                bidItem.quoteItemStatus=item.quoteItemStatus;
                // console.log("bidItem.quotesatatus-----",bidItem.quoteItemStatus);
                if (bidItem.itemStatus === 8) {

                  const bids = bid.estimateItem?.[item.itemName] || [];
                  // console.log("Item Name:", item.itemName);
                  // console.log("Bids:", bids);
                  // console.log("Part Types:", bids.map(b => b.partType));
                  // const oemBid = bids.find(b => b.partType === 'OEM') || null;
                  // const oesBid = bids.find(b => b.partType === 'OES') || null;
                  // const oemBid = bids.find(b => b.partType?.toUpperCase() === 'OEM') || null;
                  // const oesBid = bids.find(b => b.partType?.toUpperCase() === 'OES') || null;
                  const oemBid = [...bids].reverse().find(b => b.partType?.toUpperCase() === 'OEM') || null;
                  const oesBid = [...bids].reverse().find(b => b.partType?.toUpperCase() === 'OES') || null;
                  // console.log("OEM Bid:", oemBid);
                  // console.log("OES Bid:", oesBid);
                  const selectedBid = oemBid || oesBid;
                  if (!selectedBid) return;

                  // ✅ CREATE UI WRAPPER (NO self reference)
                  const uiItem = {
                    ...selectedBid, // copy values, not reference

                    // item level data
                    itemName: item.itemName,
                    itemQuantity: item.itemQuantity,
                    itemStatus: item.status,
                    itemId: item.id,
                    lineitemId: item.lineitemId,
                    spareQuotationId: item.spareQuotationId,
                    quoteItemStatus: item.quoteItemStatus,

                    // 🔹 keep options separately
                    oem: oemBid ? { ...oemBid } : null,
                    oes: oesBid ? { ...oesBid } : null,

                    selectedType: oemBid ? 'OEM' : 'OES'
                  };

                  this.quotationreceived.push(uiItem);
                  // console.log("quotationreceived--",this.quotationreceived)

                  this.quoteReceivedPrice +=
                    (uiItem.mrp * uiItem.itemQuantity);
                }

                // if ([4, 5, 6, 7, 9, 10].includes(bidItem.itemStatus)) {                             
                //   this.quotationapproved.push(bidItem);  

                  // console.log("quotation-approved----------",this.quotationapproved) ;      
                //   this.customerquoteid=this.quotationapproved[0].id; 
                  // console.log("this.customerquoteid----",this.customerquoteid);  
                //   this.quoteApprovedPrice = this.quoteApprovedPrice + ((bidItem.mrp)*bidItem.itemQuantity);
                //   this.quoteApprovedSellingPrice = this.quoteApprovedSellingPrice + ((bidItem.sellingPrice)*bidItem.itemQuantity);
                // }
                if ([4, 5, 6, 7, 9, 10].includes(bidItem.itemStatus)) {                             

                  const bids = bid.estimateItem?.[item.itemName] || [];

                  // const oemBid = bids.find(b => b.partType === 'OEM') || null;
                  // const oesBid = bids.find(b => b.partType === 'OES') || null;
                  // const oemBid = bids.find(b => b.partType?.toUpperCase() === 'OEM') || null;
                  // const oesBid = bids.find(b => b.partType?.toUpperCase() === 'OES') || null;
                  const oemBid = [...bids].reverse().find(b => b.partType?.toUpperCase() === 'OEM') || null;
                  const oesBid = [...bids].reverse().find(b => b.partType?.toUpperCase() === 'OES') || null;

                  const selectedBid = oemBid || oesBid;
                  if (!selectedBid) return;

                  const approvedItem = {
                    ...selectedBid,

                    itemName: item.itemName,
                    itemQuantity: item.itemQuantity,
                    itemStatus: item.status,
                    itemId: item.id,
                    lineitemId: item.lineitemId,
                    spareQuotationId: item.spareQuotationId,
                    quoteItemStatus: item.quoteItemStatus,

                    oem: oemBid ? { ...oemBid } : null,
                    oes: oesBid ? { ...oesBid } : null,

                    selectedType: oemBid ? 'OEM' : 'OES',

                    isApproved: true
                  };

                  // ✅ Approved tab
                  this.quotationapproved.push(approvedItem);

                  // ✅ Also show in received tab
                  this.quotationreceived.push(approvedItem);

                  // console.log("quotation-approved----------", this.quotationapproved);

                  this.customerquoteid = this.quotationapproved[0].id;

                  this.quoteApprovedPrice += approvedItem.mrp * approvedItem.itemQuantity;
                  this.quoteApprovedSellingPrice += approvedItem.sellingPrice * approvedItem.itemQuantity;
                }
                if ([4, 5, 6, 7, 8, 9].includes(bidItem.itemStatus)) {                             
                  this.customerQuotation.push(bidItem);            
                  this.customerQuotationPrice = this.customerQuotationPrice + (bidItem.mrp *bidItem.itemQuantity);

                }    
            }    
          });
        });
        this.parts =[];
        this.parts = this.quotationreceived.map(item => {
        return {
          // checkbox
          selected: false,
          isApproved: item.isApproved || false,
          status: item.itemStatus,
          // backend fields
          itemId: item.itemId,
          lineitemId: item.lineitemId,
          spareQuotationId: item.spareQuotationId,

          // 🔴 ADD THESE (IMPORTANT)
          oem: item.oem,
          oes: item.oes,

          // UI fields
          title: item.itemName,
          qty: item.itemQuantity,

          // default selection
            option: item.oes
            ? 'OES'
            : item.oem
              ? 'OEM'
              : null,

          // OEM display
          brandOEM: item.oem?.brand || '',
          partNumberOEM: item.oem?.partNumber || '',
          priceOEM: item.oem?.sellingPrice || 0,

          // OES display
          brandOES: item.oes?.brand || '',
          partNumberOES: item.oes?.partNumber || '',
          priceOES: item.oes?.sellingPrice || 0,

          // common
          edt: item.oem?.edt || item.oes?.edt || '',
          brand: item.oem?.brand || item.oes?.brand || '',
          partNumber: item.oem?.partNumber || item.oes?.partNumber || ''
        };
      });
      this.parts = this.parts.sort((a, b) => {
          return Number(a.isApproved) - Number(b.isApproved);
      });
      this.calculateTotals()
      this.getInsurance()   
      console.log("requestDetails?.spareRequestItemList", this.requestDetails?.spareRequestItemList)
  }
    });
  }
calculateTotals() {
  if (!Array.isArray(this.parts) || this.parts.length === 0) {
    this.totalOEM = 0;
    this.totalOES = 0;
    this.totalItems = 0;
    this.oesAvailableItems = 0;
    this.oemAvailableItems = 0;
    return;
  }

  this.totalItems = this.parts.length;

  this.totalOEM = 0;
  this.totalOES = 0;

  this.oesAvailableItems = 0;
  this.oemAvailableItems = 0;

  this.parts.forEach(p => {

    const qty = p.qty || 0;

    // OEM
    if (p.priceOEM) {
      this.totalOEM += p.priceOEM * qty;
      this.oemAvailableItems++;
    }

    // OES
    if (p.priceOES) {
      this.totalOES += p.priceOES * qty;
      this.oesAvailableItems++;
    }
  });

  // Flag to check if OES fully available
  this.isOESFull = this.oesAvailableItems === this.totalItems;
}


incrementQuantity(quote: any): void {
  quote.itemQuantity++;
  this.customerQuotationPrice = this.calculateTotalQuotationPrice();
  this.updateSelectedItemsQuote();

}

decrementQuantity(quote: any): void {
  if (quote.itemQuantity > 1) { 
    quote.itemQuantity--;
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    this.updateSelectedItemsQuote();
  }
}
  isQuoteApproved(): boolean {
    return this.quotationapproved.length > 0;
  }
  setActiveTab(tab: string, jobcardId = '',bookingId = '',quoteId = ''): void {
    this.activeTab = tab; 
  }
 
  


toggleSelectAll(): void {
  this.selectAll = !this.selectAll;
  this.quotationreceived.forEach(item => item.selected = this.selectAll);
  // console.log("this.quotationrecieved----",this.quotationreceived);
  this.updateSelectedItems();
}

toggleItemSelection(): void {
  this.selectedItemsCount = this.quotationreceived.filter(item => item.selected).length;
  this.totalSelectedPrice = this.quotationreceived
    .filter(item => item.selected)
    .reduce((total, item) => total + ((item.mrp) * item.itemQuantity), 0);
  this.selectedItemsUnit=this.quotationreceived
    .filter(item => item.selected)
    .reduce((total, item) => total +  item.itemQuantity, 0);
  // ✅ Check if all checkboxes are selected and update `selectAll`
  this.selectAll = this.selectedItemsCount === this.quotationreceived.length;

  // console.log("Selected Items Count:", this.selectedItemsCount);
  // console.log("Total Selected Price:", this.totalSelectedPrice);
}

  toggleItemSelectionQuote(): void {
    if (Array.isArray(this.customerQuotation)) {
      this.selectAllQuote = this.customerQuotation.every(quote => quote.selected);
    } else {
      this.selectAllQuote = false;
    }
   if (Array.isArray(this.selectedItemsLabourQuote)) {

      this.selectedLabourCount = this.selectedItemsLabourQuote.every(labour => labour.selected);

} else {
  this.selectedLabourCount = 0;
}
    this.labourList();
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  }
  sidebarToggleItemSelectionQuote(){
    this.toggleItemSelectionQuote();

  }
  ApprovedtoggleSelectAll(): void {
    this.selectAll = !this.selectAll;
    this.quotationapproved.forEach(item => item.selected = this.selectAll);
    // console.log("this.selectedItemsCount-----------------",this.selectedItemsCount);
    this.updateApprovedSelectedItems();
    this.anyItemSelected();
    this.ApprovedtoggleItemSelection();
  }
  
  toggleSelectAllQuote(): void {
    this.selectAllQuote = !this.selectAllQuote;
    this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);
    this.selectedItemsLabourQuote.forEach(labour => labour.selected=this.selectedLabourCount);
    // console.log("this.selectedItemsLabourQuote",this.selectedItemsLabourQuote);
    // console.log("this.customerQuotation--",this.customerQuotation);
    this.selectedLaboursCount=this.selectedLabours.length;
    this.updateSelectedItemsQuote();
    this.anyItemSelected();
    this.toggleItemSelection();

    
  }
    sidebarToggleSelectAllQuote() {
      this.selectAllQuote = !this.selectAllQuote;
    
      // Ensure customerQuotation is defined before looping
      if (Array.isArray(this.customerQuotation)) {
        this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);
      } else {
        console.error("Error: this.customerQuotation is undefined or not an array", this.customerQuotation);
      }
    
      // Ensure selectedItemsLabourQuote is defined before looping
      if (Array.isArray(this.selectedItemsLabourQuote)) {
        this.selectedItemsLabourQuote.forEach(labour => labour.selected = this.selectAllQuote);
      } else {
        console.error("Error: this.selectedItemsLabourQuote is undefined or not an array", this.selectedItemsLabourQuote);
      }
    
      // console.log("this.selectedItemsLabourQuote", this.selectedItemsLabourQuote);
      // console.log("this.customerQuotation", this.customerQuotation);
    
      // Ensure selectedLabours is defined
      this.selectedLaboursCount = this.selectedLabours ? this.selectedLabours.length : 0;
    
      // Call other functions
      this.labourList();
      this.updateSelectedItemsQuote();
    
    
    
    // this.anyItemSelected();
    // this.toggleItemSelection();

  }
  // toggleItemSelection(): void {
  //   this.selectedItemsCount = this.quotationreceived.filter(item => item.selected).length;
  //   this.totalSelectedPrice = this.quotationreceived.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
  //   console.log("this.selectedItems-----------",this.selectedItemsCount);
  //   console.log("this.totalSelectedPrice---",this.totalSelectedPrice);
  //   this.updateSelectedItemsQuote();
  //   this.updateSelectedItems();
  //   this.anyItemSelected();
  // }
  ApprovedtoggleItemSelection(): void {
    this.selectedApprovedItemsCount = this.quotationapproved.filter(item => item.selected).length;
    this.totalSelectedApprovedPrice = this.quotationapproved
      .filter(item => item.selected)
      .reduce((total, item) => total + ((item.mrp - (item.mrp * item.sellingDiscount / 100)) * item.itemQuantity), 0);
  
    // Check if all items are selected, update selectAll accordingly
    this.selectAll = this.selectedApprovedItemsCount === this.quotationapproved.length;
  
    // console.log("Selected Items Count:", this.selectedApprovedItemsCount);
    // console.log("Total Selected Price:", this.totalSelectedApprovedPrice);
  
    this.updateSelectedItemsQuote();
    this.updateApprovedSelectedItems();
    this.anyItemSelected();
  }
  
  updateApprovedSelectedItems(): void {
    this.selectedApprovedItemsCount = this.quotationapproved.filter(item => item.selected).length;
    this.totalSelectedApprovedPrice = this.quotationapproved.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
    this.totalSelectedApprovedPrice = this.quotationapproved.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
    // this.selectedItemsCount=this.selectedLabours?.length+this.selectedItemsCountQuote
    // this.selectedLaboursCount=this.selectedLabours.length;
    // console.log("Selected Items Count:", this.selectedItemsCount);
  
  }

  updateSelectedItems(): void {
    this.selectedItemsCount = this.quotationreceived.filter(item => item.selected).length;
    this.totalApprovedSelectedPrice = this.quotationapproved.filter(item => item.selected).reduce((total, item) => total+((item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity), 0);
    this.totalSelectedPrice = this.quotationreceived.filter(item => item.selected).reduce((total, item) => total+((item.mrp )*item.itemQuantity), 0);
    
  this.selectedItemsUnit=this.quotationreceived
    .filter(item => item.selected)
    .reduce((total, item) => total +  item.itemQuantity, 0);
    // this.selectedItemsCount=this.selectedLabours?.length +this.selectedItemsCountQuote;
    this.selectedItemsCount=this.selectedLabours.length + this.selectedItemsCountQuote;
    // console.log("Selected Items Count1--------------:", this.selectedItemsCount);
  
  }
  updateSelectedItemsQuote(): void {

    this.selectedItemsQuote = this.customerQuotation.filter(quote => quote.selected);
    this.selectedItemsCountQuote = this.customerQuotation.filter(quote => quote.selected).length;
  
    this.sparePartsTotal = this.customerQuotation
      .filter(quote => quote.selected)
      .reduce((total, quote) => total + (quote.mrp * quote.itemQuantity), 0);
    this.totalSelectedPriceQuote = this.sparePartsTotal + (this.totallabourSelectedPrice || 0);
    this.customerQuotationPrice = this.sparePartsTotal + (this.totallabourSelectedPrice || 0);
    this.selectedItemsCount=this.selectedLabours.length +this.selectedItemsCountQuote;
    // console.log("Selected Items Count--------------:", this.selectedItemsCount);
    // console.log("Selected Spare Parts Total:", this.sparePartsTotal);
    // console.log("Selected Labour Total:", this.totallabourSelectedPrice || 0);
    // console.log("Combined Total Price:", this.totalSelectedPriceQuote);
  }

  updateSelectedLabourItems(): void {
    this.selectedLabours = this.labourListData.filter(labour => labour.selected);
    this.selectedLabourslength = this.labourListData.filter(labour => labour.selected).length;
    this.selectedItemsLabourQuote = this.selectedLabours;
    // console.log('SelectedLabours:', this.selectedLabourslength);
  
    // this.selectedItemsCount = this.selectedLabours.length;
    this.totallabourSelectedPrice = this.selectedLabours.reduce((sum, labour) => {
      return sum + (labour.labourAmount || 0);
    }, 0);
    // this.selectedLabourCount = this.selectedItemsLabourQuote.every(labour => labour.selected);
    // this.selectedLabourCount=this.selectedLabourCount.length;
    this.totalSelectedPriceQuote = this.totallabourSelectedPrice + (this.sparePartsTotal || 0);
    this.customerQuotationPrice = this.totalSelectedPriceQuote;
    this.selectedLaboursCount=this.selectedLabours.length || 0;
  this.selectedItemsCount=this.selectedLaboursCount.length +this.selectedItemsCountQuote
    // console.log("Selected Items Count:", this.selectedItemsCount);
    // console.log("Total Selected Labour Price:", this.totallabourSelectedPrice);
  }
  
  anyItemSelected() {
    return this.selectedItemsCount > 0;
  }
  anyItemSelectedQuote() {
    return this.selectedItemsCountQuote > 0;
  }
  totalAmount(): number {
    return this.items.filter(item => item.selected).reduce((total, item) => total + item.price, 0);
  }
  totalAmountQuote(): number {
    return this.items.filter(quote => quote.selected).reduce((total, item) => total + item.price, 0);
  }

  // totalApprovedAmount(): number {
  //   return this.quotationapproved.reduce((total, item) => total + item.mrp, 0);
  // }
  
  calculateDiscountedPrice(mrp: number, discount: number): number {
    return mrp - (mrp * discount / 100);
  }
  
  openSidebar(itemdata): void {
    // console.log('Item Data:', itemdata);
    this.itemDetails=[];
    this.itemDetails=itemdata;
    this.itemDetails.discountedPrice = this.calculateDiscountedPrice(itemdata.mrp, itemdata.discount);
    this.sidebarOpen = true;


    // this.itemDetails.brandName = itemdata.bidDetails?.[0]?.estimateItem?.Battery?.[0]?.brand;

    // this.sidebarOpen = true;
    

  }
  openEditDialog(itemQuotes){
    // console.log("VK--",itemQuotes)
    this.itemQuote=[];
    this.itemQuote=itemQuotes;
    this.itemQuote.discountedPrice = this.calculateDiscountedPrice(itemQuotes.mrp, itemQuotes.discount);
    this.isPopupOpenEdit = true;
    this.selectedItemsCountQuote = 0;
    this.customerQuotation.forEach(quote => {
      quote.selected = false;
    });
    this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote=false);
  }
  closePopupEdit(): void {
    this.isPopupOpenEdit = false;
  }
 
  closeSidebar(): void {
    this.sidebarOpen = false;
  }

 approveQuote() {
  let spareRequestItems = [];

  this.parts.forEach(p => {
    if (p.selected === true) {

      // 🔹 determine selected OEM / OES
      const selectedPart =
        p.option === 'OES'
          ? p.oes
          : p.oem;

      if (!selectedPart || !selectedPart.partNumber) return;

      spareRequestItems.push({
        itemId: p.itemId,
        lineitemId: p.lineitemId,
        spareQuotationId: p.spareQuotationId,
        partNumber: selectedPart.partNumber
      });
    }
  });

  // console.log('spareRequestItems', spareRequestItems);

    const garageKey = localStorage.getItem('garageKey');
    const userKey = localStorage.getItem('spareUserKey');
  
    // Approve the selected quotes
    this.aspRequestDetailsService.approveQuote(garageKey, spareRequestItems, userKey).subscribe(result => {
      const res = JSON.parse(JSON.stringify(result));
  
      if (res.code == 200) {
        this.approveData=res.data;
        // Show pop-up after approval
        this.getAllRequestPopup(res.data.id, res.data.approvedAt);
  
        // Automatically switch to the "quote-approved" tab after pop-up
        this.setActiveTab('quote-approved');
  
        // Reload the approved quotes
        this.reloadApprovedQuotes(spareRequestItems);
  
        // Remove approved items from the quote-received array
        this.quotationreceived = this.quotationreceived.filter(item => !item.selected);
  
        // Reset the selected count and total selected price
        this.selectedItemsCount = 0;
        this.totalSelectedPrice = 0;
        this.selectedItemsUnit= 0;
        this.selectAll = false;
        
      }
    });
  }

 
  getAllRequestPopup = (id, approvedAt) => {
  //     this.zone.run(() => {
  //       this.dialog.open(AspRequestDetailsPopUpComponent,{
  //         "data":{
  //           "id":id,
  //           "approvedAt":approvedAt,
  //         }
  //        });
  //      });
  this.approved=!this.approved
   }

  calculateMRP(item: any): number {
    this.quotationapproved.forEach
    return (item.mrp - (item.mrp * item.sellingDiscount / 100)) * item.itemQuantity;
  }

  calculateTotalMRP(): void {
    this.totalMRP = this.items.reduce((total, item) => {
      return total + this.calculateMRP(item);
    }, 0);
  }

  reloadApprovedQuotes(spareRequestItems) {
    const newApprovedItems = this.quotationreceived.filter(item => spareRequestItems.some(approved => approved.itemId === item.itemId));
    
    // Add only new items to the approved list
    this.quotationapproved.push(...newApprovedItems);
  // console.log("this.quotationapproved.-----------",this.quotationapproved);
    // Recalculate total approved price
    this.quoteApprovedPrice = this.quotationapproved.reduce((total, item) => 
      total + ((item.mrp ) * item.itemQuantity), 0);
  }
  
  
  
  openSidebarQuote(): void {

    this.selectedItems = this.customerQuotation;

    // Generate random 7-digit ID for items with null or undefined `itemId`
    this.selectedItems.forEach(item => {
      if (!item.itemId) {
        item.itemId = Math.floor(1000000 + Math.random() * 9000000);
        // console.log('Generated random itemId:', item.itemId);
      }
    });

    let items = this.selectedItems.map(item => ({
      id: item.itemId,
      itemName: item.itemName,
      itemQuantity: item.itemQuantity,
      partNumber: item.partNumber,
      sellingPrice: item.mrp,
      mrp: item.mrp,
      gstRate: item.gstRate,
      hsnCode: item.hsnCode,
      brand: item.brand,
      quantity:item.itemQuantity
    }));

    localStorage.setItem('activeTab', JSON.stringify({"name":"quotation", "type": "create"}));
    localStorage.setItem('requestedQuoteItems', JSON.stringify(items));
    
    
    const factory = this.resolver.resolveComponentFactory(AspJobcardQuotationComponent);
    const componentRef = this.createQuotationContainer.createComponent(factory);
    const componentBInstance = componentRef.instance as AspJobcardQuotationComponent;
    componentBInstance.requestId = this.id;
    componentBInstance.openSidebarQuote();  
  }
  
  openSidebarQuote1(): void 
  {
    this.sidebarOpenQuote = true; 
  } 
   CloseSidebarQuote(): void {
    this.sidebarOpenQuote = false;   
  }
  approveNow(){
    this.activeTab = 'quote-received';
  }

  save(): void {
    // Find the index of the current item in the customerQuotation array
    const index = this.customerQuotation.findIndex(i => i.name === this.itemQuote.name);

    // If the item exists, update it
    if (index ) {
        // Update the item in the list with the new unit price and recalculate total amount
        this.customerQuotation[index].mrp = this.itemQuote.mrp;
        this.customerQuotation[index].totalAmount = this.itemQuote.mrp * this.itemQuote.itemQuantity;
        }
          // Recalculate the total quotation price
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    // Close the popup after saving
    this.closePopupEdit();

  }
  calculateTotalQuotationPrice(): number {
    // Recalculate total price by summing up all items' total amounts
    return this.customerQuotation.reduce((sum, item) => sum + (item.mrp * item.itemQuantity), 0);
  }

  // submitData() {
  //   this.quoteId = '1855';
  //   if (!this.quoteId) {
  //     // Filter selected items
  //     this.selectedItems = this.customerQuotation.filter(quote => quote.selected);

  //     // console.log('Selected Items:', this.selectedItems);

  //     // Generate random 7-digit ID for items with null or undefined `itemId`
  //     this.selectedItems.forEach(item => {
  //       if (!item.itemId) {
  //         item.itemId = Math.floor(1000000 + Math.random() * 9000000);
  //         // console.log('Generated random itemId:', item.itemId);
  //       }
  //     });

  //     const selectedPartNumbers = this.selectedItems.map(item => item.partNumber);
  //     // console.log("Part Numbers:", selectedPartNumbers);

  //     let labour = [];
      
  //     // console.log("Selected Labour Quotes:", this.selectedItemsLabourQuote);
      
  //     if (this.selectedItemsLabourQuote && this.selectedItemsLabourQuote.length > 0) {
  //       labour = this.selectedItemsLabourQuote.map(labour => ({
  //         labourId: labour.labourId ,
  //         labourName: labour.labourName,
  //         labourAmount: labour.labourAmount || 0, // Ensure labourAmount is not undefined
  //       }));
  //     }
  //     // console.log("this.selectedItems--",this.selectedItems);
  //     const cleanData = {
  
  //       bidId: this.selectedItems[0]?.bidId,
  //       garageKey: localStorage.getItem('garageKey'),
        
  //       items: this.selectedItems.map(item => ({
  //         id: item.itemId,
  //         partName: item.itemName,
  //         itmQty: item.itemQuantity,
  //         partNumber: item.partNumber,
  //         sellingPrice: item.mrp,
  //         mrp: item.mrp,
  //         gstRate: item.gstRate,
  //         hsnCode: item.hsnCode,
  //       })),
  //       labourItems: labour, // Use the correctly mapped labour array
  //       registrationNumber:  this.regno ?? this.registrationNumber ?? null,
  //       requestId: this.id,
  //       userKey: localStorage.getItem('spareUserKey'),
  //       jobcardId: 996
  //       // ...(this.jobCard['id'] ? { jobcardId: this.jobCard['id'] } : {})
        

  //     };

  //     // console.log("Payload being sent to API:", cleanData);

  //     this.aspRequestDetailsService.submitData(cleanData).subscribe(
  //       response => {
  //         this.resData = response['data'];
  //         this.dataid = response['data'].id;
  //         console.log('Job Card Created Response:', response);
  //       },
  //       error => {
  //         console.error('Error occurred:', error);
  //       }
  //     );
  //   } else {
  //     this.submitDataUpdate();
  //   }
  // }


  formatOrderDeliveryTime(confirmTime: string, deliveryTime: string) {
    try {
      const confirmDate = new Date(confirmTime.replace(" ", "T"));
      const deliveryDate = new Date(deliveryTime.replace(" ", "T"));

      if (isNaN(confirmDate.getTime()) || isNaN(deliveryDate.getTime())) {
        return '0 minutes';
        
      }

      const diffMs = deliveryDate.getTime() - confirmDate.getTime();
      const diffMins = Math.floor(diffMs / 60000);

      if (diffMins < 0) {
        return '0 minutes';
        
      }

      if (diffMins <= 180) {
        return `${diffMins} minutes`;
      } else {
        const hours = Math.floor(diffMins / 60);
        const minutes = diffMins % 60;
        return `${hours}H ${minutes} min`;
      }

    } catch (error) {
      return '0 minutes';
    }
  }
  submitDataUpdate() {
    // if (this.quoteId) {
    
    // Create a clean data object with only the required fields
    this.selectedItems = this.customerQuotation.filter(quote => quote.selected)
    this.selectedItems.forEach(item => {
      this.item=item.bidId;
    });
    
    const cleanData1 = {
      
      bidId: this.item,
      garageKey: localStorage.getItem('garageKey'),
      items: this.selectedItems.map(item => ({
        id: item.itemId,
        itemName: item.itemName,
        itmQty: item.itemQuantity,
        partNumber: item.partNumber,
        sellingPrice: item.mrp,
        mrp: item.mrp,
        gstRate: item.gstRate,
        hsnCode: item.hsnCode,
      })),
      quoteId: this.quoteId,
      registrationNumber: this.regno ?? this.registrationNumber ?? null,
      requestId: this.id,
      userKey:localStorage.getItem('spareUserKey'),
    };

    // console.log('update quote', cleanData1);
    
    this.aspRequestDetailsService.submitDataUpdate(cleanData1).subscribe(response => {
      this.resData=response['data']
      console.error('response11:',response );
    });
  }


  goBack(): void {
    // this.location.back();
    this.router.navigate(['my-request']); 
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    return dateString.split(' ')[0]; // Extract only YYYY-MM-DD
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  addToCustomerQuote(){        
    // Filter selected items
    this.selectedItems = this.customerQuotation.filter(quote => quote.selected);
    // console.log(this.selectedItems);

    // Generate random 7-digit ID for items with null or undefined `itemId`
    this.selectedItems.forEach(item => {
      if (!item.itemId) {
        item.itemId = Math.floor(1000000 + Math.random() * 9000000);
        // console.log('Generated random itemId:', item.itemId);
      }
    });

    let items = this.selectedItems.map(item => ({
        id: item.itemId,
        itemName: item.itemName,
        itemQuantity: item.itemQuantity,
        partNumber: item.partNumber,
        sellingPrice: item.mrp,
        mrp: item.mrp,
        gstRate: item.gstRate,
        hsnCode: item.hsnCode,
        brand: item.brand,
        quantity:item.itemQuantity
      }));

    if (!this.quoteId || this.quoteId=='0') {
      localStorage.setItem('activeTab', JSON.stringify({"name":"quotation", "type": "create"}));
      localStorage.setItem('requestedQuoteItems', JSON.stringify(items));
      this.router.navigate(['my-job-cards-details/'+this.jobcardId+'/'+this.bookingId]);
    }else{
      this.isQuotationPopup = true;
    }    
  }

  editQuotationItems(){
    // Filter selected items
    this.selectedItems = this.customerQuotation.filter(quote => quote.selected);
    // console.log(this.selectedItems);

    // Generate random 7-digit ID for items with null or undefined `itemId`
    this.selectedItems.forEach(item => {
      if (!item.itemId) {
        item.itemId = Math.floor(1000000 + Math.random() * 9000000);
        // console.log('Generated random itemId:', item.itemId);
      }
    });

    let items = this.selectedItems.map(item => ({
        id: item.itemId,
        itemName: item.itemName,
        itemQuantity: item.itemQuantity,
        partNumber: item.partNumber,
        sellingPrice: item.mrp,
        mrp: item.mrp,
        gstRate: item.gstRate,
        hsnCode: item.hsnCode,
        brand: item.brand,
        quantity:item.itemQuantity
      }));

    localStorage.setItem('activeTab', JSON.stringify({"name":"quotation", "type": "edit"}));
    localStorage.setItem('requestedQuoteItems', JSON.stringify(items));
    this.router.navigate(['my-job-cards-details/'+this.jobcardId+'/'+this.bookingId]);
  }


  closeQuotationPopup(){
    this.isQuotationPopup = false;
  }

  getStatus(): string {
  if (this.filteredOrderList.length > 0 && this.requestDetails?.spareRequest?.status==1) {
    return '📦 Order Created';
  } else if (this.quotationapproved.length > 0 && this.filteredOrderList.length == 0 && this.requestDetails?.spareRequest?.status==1) {
    return '✅ Quote Approved';
  } else if (this.quotationreceived.length > 0 && this.quotationapproved.length == 0 && this.filteredOrderList.length == 0 && this.requestDetails?.spareRequest?.status==1) {
    return '💬 Quote Received';
  } else if (this.quotationreceived.length == 0 && this.quotationapproved.length == 0 && this.filteredOrderList.length == 0 && this.requestDetails?.spareRequest?.status==1) {
    return '⏳ Requested';
  } else if(this.requestDetails?.spareRequest?.status==0){
    return '❌ Cancelled';
  }
}
goToRequest(){
   this.activeTab = 'requests';
}
shareRequestViaWhatsApp() {
  // ✅ Construct WhatsApp message
  const message =`✅ *Quotation Approved*

Hello Autoverse Team,
We have *approved the quotation on the system* for the below request. Please proceed with order creation and dispatch.

*Request ID:*  ${this.requestDetails?.spareRequest?.id}
*Car:* ${this.requestDetails?.spareRequest?.make} ${this.requestDetails?.spareRequest?.model} ${this.requestDetails?.spareRequest?.manufacturingYear} ${this.requestDetails?.spareRequest?.variant} – ${this.requestDetails?.spareRequest?.fuelType} (${this.requestDetails?.spareRequest?.registrationNumber})

*Approved Parts:*
${this.parts?.map((part: any) => `→ ${part.title} – ${part.qty} unit${part.qty > 1 ? 's' : ''}`).join('\n')}

🚚 Kindly process the order without delay.
👉 View Approved Quote here: ${GlobalVariable.AUTOVERSE_WEB}/request/request-details?id=${this.requestDetails?.spareRequest?.id}&tab=approve `;
// https://www.autoversemobility.in/request/${this.requestDetails?.spareRequest?.id}/tab_apr
  const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');

  this.aspLoadingService.hide();
}
// shareQuoteReceivedViaWhatsApp() {
//   const garageName = localStorage.getItem('spareSelectedGarageName') || 'Garage Partner';
//   const message = `📄 *Quotation Created*

// Hello *${garageName}*,

// A quotation has been created on the system for the below request. Please review and proceed with the next steps as required.

// *Request ID:* ${this.requestDetails?.spareRequest?.id}
// *Car:* ${this.requestDetails?.spareRequest?.make} ${this.requestDetails?.spareRequest?.model} ${this.requestDetails?.spareRequest?.manufacturingYear} ${this.requestDetails?.spareRequest?.variant} – ${this.requestDetails?.spareRequest?.fuelType} (${this.requestDetails?.spareRequest?.registrationNumber})

// *Quoted Parts:*
// ${this.quotationreceived?.map((part: any) =>
//   `→ ${part.itemName} – ${part.itemQuantity} unit${part.itemQuantity > 1 ? 's' : ''}`
// ).join('\n')}

// 👉 *View Quote here:* ${GlobalVariable.AUTOVERSE_WEB}/request/request-details?id=${this.requestDetails?.spareRequest?.id}&tab=received

// ⏳ Awaiting approval to proceed further.`;

//   const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
//   window.open(whatsappUrl, '_blank');

//   this.aspLoadingService.hide();
// }
shareQuoteReceivedViaWhatsApp() {
  const garageName = localStorage.getItem('spareSelectedGarageName') || 'Garage Partner';

  // Only include items that are NOT approved
  const pendingItems = this.quotationreceived?.filter(part => !part.isApproved);

  const message = `📄 *Quotation Created*

Hello *${garageName}*,

A quotation has been created on the system for the below request. Please review and proceed with the next steps as required.

*Request ID:* ${this.requestDetails?.spareRequest?.id}
*Car:* ${this.requestDetails?.spareRequest?.make} ${this.requestDetails?.spareRequest?.model} ${this.requestDetails?.spareRequest?.manufacturingYear} ${this.requestDetails?.spareRequest?.variant} – ${this.requestDetails?.spareRequest?.fuelType} (${this.requestDetails?.spareRequest?.registrationNumber})

*Quoted Parts:*
${pendingItems.map((part: any) =>
  `→ ${part.itemName} – ${part.itemQuantity} unit${part.itemQuantity > 1 ? 's' : ''}`
).join('\n')}

👉 *View Quote here:* ${GlobalVariable.AUTOVERSE_WEB}/request/request-details?id=${this.requestDetails?.spareRequest?.id}&tab=received

⏳ Awaiting approval to proceed further.`;

  const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');

  this.aspLoadingService.hide();
}

setOption(p: any, type: 'OEM' | 'OES') {

  // OES not available
  if (type === 'OES' && !p.oes) {
    this.toastr.error('OES part not available for this item');
    return;
  }

  // OEM not available
  if (type === 'OEM' && !p.oem) {
    this.toastr.error('OEM part not available for this item');
    return;
  }

  // valid selection
  p.option = type;
}



 setAll(type: 'OEM' | 'OES') {
  let skippedItems: string[] = [];

  this.parts.forEach(p => {

    // OES requested but not available
    if (type === 'OES' && !p.oes) {
      skippedItems.push(p.title);
      return;
    }

    // OEM requested but not available
    if (type === 'OEM' && !p.oem) {
      skippedItems.push(p.title);
      return;
    }

    // valid → set option
    p.option = type;
  });

  // show toast if any skipped
  if (skippedItems.length) {
    this.toastr.warning(
      `${skippedItems.length} part(s) don’t have ${type} option`,
      'Selection partially applied'
    );
  }
}


  // resetRecommendation() {
  //   this.parts = this.parts.map(p => ({
  //     ...p,
  //     option: p.recommended
  //   }));
  // }

getSelectedPrice(p: any): number {
  return p.option === 'OEM' ? p.priceOEM : p.priceOES;
}


  get selectedParts() {
    return this.parts.filter(p => p.selected);
  }

  get total() {
    return this.selectedParts.reduce(
      (sum, p) => sum + this.getSelectedPrice(p) * p.qty,
      0
    );
  }

get oesSavings(): number {
  return this.parts?.reduce((total, p) => {
    if (p.selected && p.option === 'OES') {
      const oemPrice = p.priceOEM || 0;
      const oesPrice = p.priceOES || 0;
      return total + ((oemPrice - oesPrice) * p.qty);
    }
    return total;
  }, 0) || 0;
}

  get hasOESSelected() {
    return this.selectedParts.some(p => p.option === 'OES');
  }

  get approveLabel() {
    return `Approve Selected (${this.selectedParts.length} items) — ₹${this.total.toLocaleString()}`;
  }

  close() {
    this.openPopup=!this.openPopup;
  }

  downloadOES() {
    // console.log("Download OES PDF");
  }

  downloadOEM() {
    // console.log("Download OEM PDF");
  }

  shareWhatsApp() {
    // console.log("Share WhatsApp");
  }
 toggleEditMenu( event: Event) {
  event.stopPropagation();
  this.openEditIndex = !this.openEditIndex
}
addMoreItems(list: any) {
  this.openEditIndex=false;
// console.log("list", list);
  // 🔹 Store selected vehicle (sidebar reads from here)
  localStorage.setItem('carNumber', list.regNo || list.registrationNumber);
  localStorage.setItem('selectedMake', list.make);
  localStorage.setItem('selectedModel', list.model);
  localStorage.setItem('variant', list.variant);
  localStorage.setItem('fuelType', list.fuelType);
  localStorage.setItem('selectedYear', list.manufacturingYear);
  localStorage.setItem('variantKey', list.variantKey);
  localStorage.setItem('rowKey', list.rowKey);
  localStorage.setItem('addMoreItemsId', list.id);

  // 🔹 Create sidebar dynamically
  const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
  const componentRef = this.containers.createComponent(factory);
  const componentInstance = componentRef.instance as AspInstantRequestComponent;

  // 🔹 Open ONLY Parts Entry sidebar
  componentInstance.closeDetails(false);        // optional (if details must close)
  componentInstance.closetext(true);       // ✅ THIS is what you want
}

goBackList(){
    this.isInsurance=false;
    this.selectedType='';
    this.selectedCompany = '';
    this.insuranceGarageId='';
    this.showError = false;
    this.showError1 = false; 
}
getInsurance(){
    this.aspMyRequestService.getInsurance().subscribe(
      result => {
        // console.log("result",result);
        this.insurance=result['data']
    //         const navState: any = this.location.getState();
    // if (navState?.triggerFunction) {
    //   this.loadInstantDetails();
    // }
    // if(localStorage.getItem('instantOrder')=='2'){
    // this.loadInstantDetails();
    // }
      })
  
}
  get isContinueActive(): boolean {
  // active if non-insurance, or insurance + company selected
  return (
    this.selectedType === 'non-insurance' ||
    (this.selectedType === 'insurance' && !!this.selectedCompany)
  );
}
  showPopup(){
    this.showPopupinfo=true;
  }
  closePopup(){
    this.showPopupinfo=false;
  }
  selectType(type: string): void {
    this.selectedType = type;
    this.showError = false;   
    if (type === 'insurance') {
      if(this.insurance.length<=1){
        this.selectCompany(this.insurance[0])
      }else{
      this.filteredList = [...this.insurance]; // show all initially
      }
    } else {
      this.selectedCompany = null;
      this.searchText = '';
    }
  }
    onSearchChange(): void {
    const query = this.searchText.trim().toLowerCase();
    if (!query) {
      this.filteredList = [...this.insurance];
    } else {
      this.filteredList = this.insurance.filter(c =>
        c.insuranceGarageName.toLowerCase().includes(query)
      );
    }
  }
      selectCompany(company: string): void {
      
    this.showError1 = false;   
    this.selectedCompany = company['insuranceGarageKey'];
    this.insuranceGarageId=company['insuranceGarageId'];
    // console.log('Selected company:', company);
  }
  updateInsurance(){
     if (!this.selectedType  ) {
      this.showError = true; 
    }else if(this.selectedType=="insurance" && !this.selectedCompany){
      this.showError1 = true; 
    }else{
  let type;
      if(this.selectedType=="insurance"){
         type=true;
      }else{
         type=false;
      }
    let insurerId;
      if(this.selectedCompany==null){
        insurerId = 0;
      }else{
        insurerId=this.insuranceGarageId;
      }
     this.aspMyRequestService.UpdateInsurance(this.requestDetails?.spareRequest?.id,type,insurerId).subscribe(
      result => {
        // console.log("result", result);
        this.toastr.success(result['response'].message);
        
    this.aspLoadingService.show();
     this.getRequestDetails();
  this.goBackList();

      })
}
}
editRequest(id: any) {

  this.openEditIndex = null;
  this.isInsurance=true;
} 

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const files = Array.from(input.files);

    for (const file of files) {

      // 🔒 Allow only images
      if (!file.type || !file.type.startsWith('image/')) {
        continue;
      }

      // 🔁 Avoid duplicates
      const exists = this.selectedImages.some(
        img =>
          img.name === file.name &&
          img.size === file.size &&
          img.lastModified === file.lastModified
      );

      if (exists) {
        continue;
      }

      this.selectedImages.push(file);

      const reader = new FileReader();
      reader.onload = () => {
      this.imagePreviews.push({
          id: 0, // ⬅️ temporary (real ID will come after upload API)
          url: reader.result as string
        });
      };
      reader.readAsDataURL(file);
    }

    // Reset input
    input.value = '';
     if (this.spareRequestId) {
        this.uploadAllSpareImages();
      } else {
        console.warn("⚠️ Request ID not loaded yet — cannot upload images");
      }
  }

  // removeImage(index: number): void {
  //   this.selectedImages.splice(index, 1);
  //   this.imagePreviews.splice(index, 1);
  // }
removeImage(index: number): void {
  const image = this.imagePreviews[index];
  if (!image) return;

  const garageKey = localStorage.getItem('garageKey') || '';

  // console.log("Deleting image ID:", image.id);

  // 🗑 If image exists on server → call API
  if (image.id && image.id !== 0) {
    this.aspRequestDetailsService
      .deleteSpareRequestImage(garageKey, image.id.toString())
      .subscribe({
        next: () => {
          // console.log("✅ Deleted from server");
          this.toastr.success("Image removed successfully");
        },
        error: err => {
          console.error("❌ Delete failed", err);
          this.toastr.error("Failed to remove image");
        }
      });
  } else {
    // 🧹 Just a local preview image
    this.toastr.success("Image removed");
  }

  // Remove from UI instantly
  this.imagePreviews.splice(index, 1);
}

  goToQuoteApproved(){
    this.approved=false;
    this.ngOnInit();
  }

  //   uploadAllSpareImages() {
  //   console.log("uploadAllSpareImages called");
  //   console.log("Request ID:", this.spareRequestId);
  //   console.log("Selected Images:", this.selectedImages); // ✅ FIXED

  //   if (!this.spareRequestId || this.selectedImages.length === 0) {
  //     console.log("❌ No images selected — upload stopped");
  //     return;
  //   }

  //   const garageKey = localStorage.getItem("garageKey") || '';
  //   if (!garageKey) {
  //     this.toastr.error("Garage key not found");
  //     return;
  //   }

  //   this.selectedImages.forEach(file => {
  //     this.aspRequestDetailsService
  //         .uploadSpareRequestImage(this.spareRequestId, garageKey, file)
  //         .subscribe({
  //             next: res => console.log("Uploaded:", file.name, res),
  //             error: err => console.error("Failed:", file.name, err)
  //         });
  //   });
  //   // Clear after upload
  //   this.selectedImages = [];
  //   this.imagePreviews = [];
  // }
  uploadAllSpareImages() {
  // console.log("uploadAllSpareImages called");

  if (!this.spareRequestId || this.selectedImages.length === 0) {
    // console.log("❌ No images selected — upload stopped");
    return;
  }

  const garageKey = localStorage.getItem("garageKey") || '';
  if (!garageKey) {
    this.toastr.error("Garage key not found");
    return;
  }

  this.selectedImages.forEach((file, index) => {
    this.aspRequestDetailsService
      .uploadSpareRequestImage(this.spareRequestId, garageKey, file)
      .subscribe({
        next: (res: any) => {
          // console.log("✅ Uploaded:", file.name, res);

          // 🔥 IMPORTANT — update preview with real ID from server
          if (res?.entityId) {
            const previewIndex = this.imagePreviews.findIndex(p => p.id === 0);
            if (previewIndex !== -1) {
              this.imagePreviews[previewIndex].id = res.entityId;
              this.imagePreviews[previewIndex].url = res.url; // if API returns final URL
            }
          }
        },
        error: err => console.error("❌ Failed:", file.name, err)
      });
  });

  // ✅ Only clear selectedImages (not previews)
  this.selectedImages = [];
}
openImagePreview(url: string) {
  this.previewImageUrl = url;
  this.imagePreviewOpen = true;
}

closeImagePreview() {
  this.imagePreviewOpen = false;
  this.previewImageUrl = null;
}

transform(availability: any): string {
    if (availability === null || availability === undefined || availability === '') {
      return '';
    }

    // Convert numeric string to number if applicable
    const numValue = Number(availability);

    if (!isNaN(numValue) && availability.toString().trim() !== '' && availability.toString().trim().match(/^\d+$/)) {
      return 'Availability: ' + numValue + ' ' + (numValue === 1 ? 'day' : 'days');
    }

    const dateValue = new Date(availability);
    if (!isNaN(dateValue.getTime()) && isNaN(numValue)) {
      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      };
      return 'Availability: ' + new Intl.DateTimeFormat('en-GB', options).format(dateValue);
    }

    const words = availability.toString().toLowerCase().split(' ');
    for (let i = 0; i < words.length; i++) {
      if (words[i].length > 0) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
    }
    return words.join(' ');
  }
  
  shareMagicQuoteOnWhatsapp() {

  const spareRequest = this.requestDetails?.spareRequest;
  const items = this.requestDetails?.spareRequestItemList || [];
  const bidDetails = this.requestDetails?.bidDetails || [];

  const availableLines: string[] = [];
  const confirmingLines: string[] = [];
  const checkingLines: string[] = [];

  items.forEach((item) => {

    let estimates: any[] = [];

    bidDetails.forEach(bid => {
      if (bid?.estimateItem?.[item.itemName]) {
        estimates = bid.estimateItem[item.itemName];
      }
    });

    if (!estimates.length) {
      checkingLines.push(`*${item.itemName}*`);
      return;
    }
const oem = estimates.find(e => e.partType?.toUpperCase() === 'OEM');
const oes = estimates.find(e => e.partType?.toUpperCase() === 'OES');

const formatPrice = (val: any) =>
  val ? `₹${Number(val.mrp || 0).toLocaleString('en-IN')}` : '';

const normalizeEdt = (val: any) =>
  (val || '').toString().trim().toLowerCase();

const oemEdt = normalizeEdt(oem?.edt);
const oesEdt = normalizeEdt(oes?.edt);

const isNumericEdt = (val: string) => /^\d+$/.test(val);

let line = '';
let finalEdt = '';


// ========================================
// CASE 1: BOTH OEM + OES EXISTS
// ========================================

if (oem && oes) {

  // BOTH SAME EDT
  if (oemEdt === oesEdt) {

    finalEdt = oemEdt;

    const edtLabel =
      isNumericEdt(finalEdt)
        ? ` [${finalEdt} Day${finalEdt === '1' ? '' : 's'}]`
        : '';

    line =
      `*${item.itemName}* - OEM - ${formatPrice(oem)}${edtLabel} | ${oes.brand || '-'} - ${formatPrice(oes)}`;
  }

  // DIFFERENT EDT
  else {

    // PRIORITY:
    // available > numeric days > confirming

    if (oemEdt === 'available' || isNumericEdt(oemEdt)) {

      finalEdt = oemEdt;

      const edtLabel =
        isNumericEdt(oemEdt)
          ? ` [${oemEdt} Day${oemEdt === '1' ? '' : 's'}]`
          : '';

      line =
        `*${item.itemName}* - OEM - ${formatPrice(oem)}${edtLabel}`;
    }

    else if (oesEdt === 'available' || isNumericEdt(oesEdt)) {

      finalEdt = oesEdt;

      const edtLabel =
        isNumericEdt(oesEdt)
          ? ` [${oesEdt} Day${oesEdt === '1' ? '' : 's'}]`
          : '';

      line =
        `*${item.itemName}* - ${oes.brand || '-'} - ${formatPrice(oes)}${edtLabel}`;
    }

    else {

      finalEdt = oemEdt || oesEdt;

      line =
        `*${item.itemName}* - OEM - ${formatPrice(oem)}`;
    }
  }
}


// ========================================
// CASE 2: ONLY OEM
// ========================================

else if (oem) {

  finalEdt = oemEdt;

  const edtLabel =
    isNumericEdt(oemEdt)
      ? ` [${oemEdt} Day${oemEdt === '1' ? '' : 's'}]`
      : '';

  line =
    `*${item.itemName}* - OEM - ${formatPrice(oem)}${edtLabel}`;
}


// ========================================
// CASE 3: ONLY OES
// ========================================

else if (oes) {

  finalEdt = oesEdt;

  const edtLabel =
    isNumericEdt(oesEdt)
      ? ` [${oesEdt} Day${oesEdt === '1' ? '' : 's'}]`
      : '';

  line =
    `*${item.itemName}* - ${oes.brand || '-'} - ${formatPrice(oes)}${edtLabel}`;
}



// ========================================
// SECTION PUSH
// ========================================

if (!finalEdt) {
  checkingLines.push(line || `*${item.itemName}*`);
}
else if (finalEdt === 'available' || isNumericEdt(finalEdt)) {
  availableLines.push(line);
}
else {
  confirmingLines.push(line);
}
  });

  // 🔥 GLOBAL ORDER FIX
  let counter = 1;

  const format = (lines: string[]) =>
    lines.map(l => `${counter++}️ ${l}`).join('\n');

  let sectionText = '';

  // 1. AVAILABLE
  if (availableLines.length) {
    sectionText += `
━━━━━━━━━━━━━━━
✅ *AVAILABLE NOW*
━━━━━━━━━━━━━━━
${format(availableLines)}
`;
  }

  // 2. CONFIRMING
  if (confirmingLines.length) {
    sectionText += `
━━━━━━━━━━━━━━━
⏳ *CONFIRMING AVAILABILITY*
━━━━━━━━━━━━━━━
${format(confirmingLines)}
`;
  }

  // 3. CHECKING
  if (checkingLines.length) {
    sectionText += `
━━━━━━━━━━━━━━━
🔍 *CHECKING PRICE & AVAILABILITY*
━━━━━━━━━━━━━━━
${format(checkingLines.map(l => `*${l.replace(/\*/g, '')}*`))}
`;
  }

  const deepLink = `${GlobalVariable.AUTOVERSE_WEB}/request/request-details?id=${this.requestDetails?.spareRequest?.id}&tab=received`;

  const whatsappMessage = `
✨ *_Autoverse Magic Quote Ready_* ✨

Request ID: RQ-${spareRequest?.id}
Garage: ${localStorage.getItem("spareSelectedGarageName") || ''}
Car No: ${spareRequest?.registrationNumber || ''}

🚗 ${spareRequest?.make || ''} ${spareRequest?.model || ''} | ${spareRequest?.fuelType || ''} | ${spareRequest?.manufacturingYear || ''} | ${spareRequest?.variant || ''} | VIN ${spareRequest?.vinNumber || ''}

${sectionText}

👉 View Quote here: ${deepLink}
⏳ _Awaiting approval to proceed further_
`;

  const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(whatsappMessage)}`;

  window.open(url, '_blank');
}
}